import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class MartyrData extends Model
{
    constructor(id, personId, dateSacrifice, hospitalName, region, note, file=null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.dateSacrifice      = dateSacrifice;
        this.hospitalName       = hospitalName;
        this.region             = region;
        this.note              = note;
        this.file               = file ?? new FileInfo();

        this.init()
    }

    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        let formData = new FormData();
        formData.append('dateSacrifice', this.dateSacrifice ?? "");
        formData.append('hospitalName', this.hospitalName ?? "")
        formData.append('placeSacrificeId', this.region?.value ?? "")
        formData.append('notes', this.note ?? "")
        if(this.file?.binaryFile) formData.append('file', this.file.binaryFile);
        
        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('personId', this.personId ?? null);
        return formData;
    }
}

